import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { FormControlDesktop } from '@alfalab/core-components-form-control/esm/desktop';
import { Popover } from '@alfalab/core-components-popover/esm';
import { Arrow } from '../components/arrow/Component.js';
import { BaseSelect } from '../components/base-select/Component.js';
import { Field } from '../components/field/Component.js';
import { Optgroup } from '../components/optgroup/Component.js';
import { Option } from '../components/option/Component.js';
import { OptionsList } from '../components/options-list/Component.js';
import { Search } from '../components/search/Component.js';

var SelectDesktop = forwardRef(function (_a, ref) {
    var _b = _a.Arrow, Arrow$1 = _b === void 0 ? Arrow : _b, _c = _a.Field, Field$1 = _c === void 0 ? Field : _c, _d = _a.OptionsList, OptionsList$1 = _d === void 0 ? OptionsList : _d, _e = _a.Optgroup, Optgroup$1 = _e === void 0 ? Optgroup : _e, _f = _a.Option, Option$1 = _f === void 0 ? Option : _f, _g = _a.Search, Search$1 = _g === void 0 ? Search : _g, _h = _a.fieldProps, fieldProps = _h === void 0 ? {} : _h, restProps = __rest(_a, ["Arrow", "Field", "OptionsList", "Optgroup", "Option", "Search", "fieldProps"]);
    return (React.createElement(BaseSelect, __assign({ ref: ref, view: 'desktop', Option: Option$1, Field: Field$1, fieldProps: __assign({ FormControlComponent: FormControlDesktop }, fieldProps), Search: Search$1, Optgroup: Optgroup$1, OptionsList: OptionsList$1, Arrow: Arrow$1, Popover: Popover }, restProps)));
});

export { SelectDesktop };
